<div class="flex flex-col fill">
  <mic-header color="white">
    <div class="flex flex-row items-center justify-between">
      <div class="flex flex-row flex-none items-center">
        <button
          type="button"
          class="side-nav-toggle"
          aria-controls="side-nav"
          [attr.aria-expanded]="sideNavOpen"
          [attr.aria-label]="sideNavOpen ? 'Fechar menu' : 'Abrir menu'"
          (click)="toggleSideNav()">
          <mat-icon>{{ sideNavOpen ? 'close' : 'menu' }}</mat-icon>
        </button>
        <a routerLink="/" class="logo-link" aria-label="Ir para a home">
          <img [src]="darkMode ? 'assets/images/logoWhite.png' : 'assets/images/logo.png'" alt="Michelin" class="header-logo" />
        </a>
      </div>
      <mic-navbar-spacer></mic-navbar-spacer>
      <span class="title md-hidden"></span>
      <mic-navbar-spacer></mic-navbar-spacer>
      <div class="flex flex-row flex-none gap-2 items-center">
        <mic-navbar-spacer fxFlex="1"></mic-navbar-spacer>
        <mic-navbar-links>
        </mic-navbar-links>
        <button mat-icon-button class="mic-icon-button-medium" aria-label="Set theme" (click)="setTheme()">
          <mat-icon>{{ darkMode ? 'light_mode' : 'bedtime' }}</mat-icon>
        </button>

        <!-- Avatar menu -->
        <button class="avatar-btn" [matMenuTriggerFor]="userMenu" aria-label="Menu do usuário">
          <span class="avatar-initials">{{ userInitials }}</span>
        </button>

        <mat-menu #userMenu="matMenu" xPosition="before" class="avatar-menu-panel">
          <div class="avatar-menu-header">
            <span class="avatar-menu-name">{{ userName || 'Usuário' }}</span>
          </div>
          <button mat-menu-item (click)="goToProfile()">
            <mat-icon>person</mat-icon>
            <span>Minha conta</span>
          </button>
          <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>Sair</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </mic-header>
  <div class="app-shell">
    <div class="side-nav-backdrop" *ngIf="sideNavOpen" (click)="closeSideNav()" aria-hidden="true"></div>

    <aside
      id="side-nav"
      class="side-nav"
      [class.is-open]="sideNavOpen"
      [class.is-collapsed]="railCollapsed"
      (mouseleave)="railCollapsed = false"
      (keydown)="railCollapsed = false">
      <nav aria-label="Navegação principal">
        <ul class="side-nav__list">
          <li *ngFor="let item of navItems">
            <a
              *ngIf="item.route; else actionItem"
              class="side-nav__item"
              [routerLink]="item.route"
              routerLinkActive="is-active"
              [routerLinkActiveOptions]="{ exact: !!item.exact }"
              ariaCurrentWhenActive="page"
              [attr.title]="item.label"
              (click)="onNavClick($event)">
              <mat-icon aria-hidden="true">{{ item.icon }}</mat-icon>
              <span class="side-nav__label">{{ item.label }}</span>
            </a>
            <ng-template #actionItem>
              <button
                type="button"
                class="side-nav__item"
                [disabled]="!item.action"
                [attr.title]="item.soon ? item.label + ' (em breve)' : item.label"
                (click)="runNavAction(item, $event)">
                <mat-icon aria-hidden="true">{{ item.icon }}</mat-icon>
                <span class="side-nav__label">{{ item.label }}</span>
                <span *ngIf="item.soon" class="side-nav__flag">Em breve</span>
              </button>
            </ng-template>
          </li>
        </ul>
      </nav>
    </aside>

    <main class="app-content">
      <router-outlet></router-outlet>

      <footer class="site-footer">
        <div class="site-footer__inner">
          <ul class="site-footer__social">
            <li *ngFor="let link of socialLinks">
              <a class="social-pill" [href]="link.href" target="_blank" rel="noopener noreferrer">
                <svg class="social-pill__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                  <rect x="3" y="3" width="18" height="18" rx="5.5" />
                  <circle cx="12" cy="12" r="4.2" />
                  <circle cx="17.4" cy="6.6" r="1" class="dot" />
                </svg>
                {{ link.label }}
                <span class="sr-only">(abre em nova aba)</span>
              </a>
            </li>
          </ul>

          <div class="site-footer__legal" [attr.title]="'Versão ' + version">
            <p class="site-footer__copyright">Copyright © 2017-{{ year }} Michelin. Todos os direitos reservados</p>
            <a routerLink="/accessibility" class="site-footer__link">Declaração de Acessibilidade</a>
          </div>
        </div>
      </footer>
    </main>
  </div>

  <button
    type="button"
    class="chat-fab"
    [attr.aria-label]="chatButtonLabel"
    [attr.aria-busy]="chatLoading ? 'true' : null"
    [matTooltip]="chatButtonLabel"
    matTooltipPosition="left"
    (click)="openChat()">
    <mat-icon aria-hidden="true">support_agent</mat-icon>
  </button>

  <mic-alert-center [hideDelay]="8"></mic-alert-center>
</div>
